<template>
  <el-form-item 
    v-if="visible"
    :label="$t('lang.喷水档位') + '：'">
    <el-select 
      :disabled="disabled" 
      @change="handleChange" 
      default-first-option
      :placeholder="$t('lang.请选择')"
      filterable 
      v-model="localValue">
      <template v-if="devMode">
        <el-option 
          v-for="r in waterGearOptions"
          :key="'waterGear_' + r" 
          :label="r"
          :value="r" />
      </template>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: 'WaterGear',
  props: {
    // v-model 绑定的值
    value: {
      type: [Number, String],
      default: null
    },
    devMode: {
      type: Object,
      default: null
    },
    permissions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    visible() {
      return this.permissions.includes('SPRAY_LEVEL');
    },
    disabled() {
      if (!this.permissions.includes('SPRAY_LEVEL')) return true;
      return !this.devMode?.waterGearChange;
    },
    waterGearOptions() {
      if (!this.devMode) return [];
      const options = [];
      for (let r = 1; r <= this.devMode.maxWaterGear + 1; r++) {
        if (r >= this.devMode.minWaterGear) {
          options.push(r - 1);
        }
      }
      return options;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleChange() {
      this.$emit('change');
    }
  }
};
</script>

